import type { JSX } from 'react'
import type { IFormProps } from '../Form'

import { Form } from '../Form'

export interface IFullWidthFormProps extends IFormProps {}

export const FullWidthForm = ({
  children,
  width = '100%',
  onSubmit,
  style,
  ...rest
}: IFullWidthFormProps): JSX.Element => (
  <Form
    width={width}
    onSubmit={onSubmit}
    style={{ position: 'relative', ...style }}
    {...rest}
  >
    {children}
  </Form>
)
